import loadable from '@loadable/component'

export const OthrIrsCreditSec = loadable(() => import('./OthrIrsCreditSec'))
export const OtherIssuers = loadable(() => import('./OtherIssuers'))
export const RelatedCredit = loadable(() => import('./RelatedCredit'), {
  resolveComponent: (module) => module.RelatedCredit
})
export const RelatedCreditRating = loadable(
  () => import('./RelatedCreditRating')
)
export type {
  otherIssuersProps,
  watchOutlookProp,
  relatedCreditItemsProps,
  OthrIrsCreditSecProps
} from './OthrIrsCreditSec'
export type { OthrIrsItemProps, OthrIrsProps } from './OtherIssuers'
export { default as OthrIrsCreditSecMocks } from './__mocks__/OthrIrsCreditSec.mock'
